import { PRIORITY, STATUS } from '@/entities/alert/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  type PagePaginationRequestDto,
  PagePaginationResponseDtoSchema,
  responseContract,
} from '../../lib';

const GetResidentAlertsResponseDtoSchema = PagePaginationResponseDtoSchema(
  z.object({
    createdAt: z.string(),
    daysOpen: z.number(),
    daysRemaining: z.number(),
    displayName: z.string(),
    id: z.number(),
    priority: z.enum(PRIORITY).nullable(),
    status: z.enum(STATUS).nullable(),
  })
);

export type GetResidentAlertsRequestDto = PagePaginationRequestDto<
  {
    residentId: number;
    alertConfigNames?: string[];
    statuses?: string[];
    priorities?: string[];
    minDaysOpen?: number | null;
  },
  | 'displayName'
  | 'status'
  | 'priority'
  | 'incidentDateTime'
  | 'daysOpen'
  | 'daysRemaining'
>;
export type GetResidentAlertsResponseDto = z.infer<
  typeof GetResidentAlertsResponseDtoSchema
>;

export const getResidentAlerts = (
  params: GetResidentAlertsRequestDto,
  config?: AxiosRequestConfig<GetResidentAlertsRequestDto>
) => {
  const { residentId, ...filterParams } = params;

  return api
    .get(`/residents/${residentId}/alerts`, {
      params: filterParams,
      ...config,
    })
    .then(responseContract(GetResidentAlertsResponseDtoSchema));
};
